import get from 'lodash/get';
import merge from 'lodash/merge';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('board', 'reqChannelParticipants', [
  'UPDATE_LIST',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'chat_rooms',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'participants',
  ],
});

const requestReducer = createReqReducer(consts);

export default (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case consts.UPDATE_LIST: {
      const { loggedUserParticipants, dependentParticipants } = payload;
      const modifiedDependentParticipants = dependentParticipants.map(item => {
        const { blocked: blockedStatusForDependent, ...rest } = item;
        return { blockedStatusForDependent, ...rest };
      });
      const updatedList = [
        ...merge(loggedUserParticipants, modifiedDependentParticipants),
      ];
      return { ...state, list: updatedList };
    }
    default:
      return requestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/board/reqChannelParticipants.js